import { IProps } from './index'

const PC900B = ({ onConnect, onCancel }: IProps) => {
  return (
    <div className="reader-view" data-reader-view="device-instructions" data-device-type="pc900b">
      <h3 className="mb-6">
        <i className="fa fa-plug"></i>
        Instructions for connecting to your CMI PC-900B device
      </h3>
      <ul className="text-left">
        <li>
          <span>1</span> Connect the CMI PC-900B device to your computer via USB.
        </li>
        <li>
          <span>2</span> Ensure the device is powered on and in data transfer mode.
        </li>
        <li>
          <span>3</span> Wait for the device to be recognized by your computer.
        </li>
      </ul>

      <div className="flex justify-center items-center space-x-2 my-6">
        <button className="btn btn-default" onClick={onCancel}>
          <i className="fa fa-reply"></i>
          Reset Another Device
        </button>
        <button className="btn btn-primary" onClick={onConnect}>
          <i className="fa fa-download"></i>
          Reset Oximeter
        </button>
      </div>
    </div>
  )
}

export default PC900B
